import {Link} from "react-router-dom"
import {useEffect, useState} from "react"
import ApiCMS from "../../services/cms"
import {eventTag} from "../../services/utils"
import lightBulbIcon from "../../assets/images/icons/light-bulb.svg"
import './index.scss'

const ApiPills = ApiCMS()

const event = {
  name: "pill",
  category: "widget",
  action: "click",
}

const itemColetanea = {
  id: "coletaneas",
  title: "Tipos de crédito para sua empresa",
  subtitle: "Guia completo sobre as principais linhas de crédito",
  link_mobile: "https://app.powerbi.com/view?r=eyJrIjoiZDRlYjIzM2MtMjgxZC00NzJjLTk1NTItMjZiZTY0MmQyOWJlIiwidCI6Ijk3Mjk4MjcxLTFiZDctNGFjNS05MzViLTg4YWRkZWY2MzZjYyIsImMiOjR9",
  link_desktop: "https://app.powerbi.com/view?r=eyJrIjoiZWNjNzU1NjctNTM1OC00MmNmLTljZTktNmExZmE2OTMwZDkxIiwidCI6Ijk3Mjk4MjcxLTFiZDctNGFjNS05MzViLTg4YWRkZWY2MzZjYyIsImMiOjR9",
}

const widgetPillFadeDelayByIndex = ["0ms", "1s", "1.5s", "2s"]

const WidgetPills = () => {
  const [pills, setPills] = useState([])

  const getPills = () => {
    ApiPills.getAllPills(1, 3)
      .then((response) => {
        const { data } = response
        setPills(data.results)
      })
      .catch((error) => {
        console.warn("ERROR: ", error)
      })
  }

  useEffect(() => {
    getPills()
  }, [])

  const recommendedContent = [...pills.slice(0, 3), itemColetanea]
  const getWidgetPillAnimationStyle = (stepIndex) => ({
    animationDelay: widgetPillFadeDelayByIndex[stepIndex] || "0ms",
  })

  return pills.length ? (
    <div
      id="pill-planning-right-driver-js"
      className="widget-pills animate__animated animate__fadeIn"
      style={{ animationDelay: "900ms" }}
    >
      <div className="widget-pills__header">
        <img src={lightBulbIcon} alt="Light bulb icon" />
        <h3 className="widget-pills-title-section">
          Conteúdo recomendado para você
        </h3>
      </div>

      <div className="widget-pills__grid">
        {recommendedContent.map((item, index) => {
          const isColetanea = item.id === "coletaneas"

          const content = (
            <div className="widget-pills__card-content">
              <span className={`widget-pills__badge ${isColetanea ? "widget-pills__badge--coletanea" : ""}`}>
                {isColetanea ? "Coletâneas" : "Pílula de Conhecimento"}
              </span>
              <h4>{item.title}</h4>
              <p>{item.subtitle}</p>
              <div className={`widget-pills__footer ${isColetanea ? "widget-pills__footer--coletanea" : ""}`}>
                <span className="widget-pills__action">
                  {isColetanea ? "Explorar" : "Assistir"}
                  <span aria-hidden="true">›</span>
                </span>
              </div>
            </div>
          )

          if (isColetanea) {
            return (
              <div
                className="widget-pills__card animate__animated animate__fadeIn"
                key={item.id}
                style={getWidgetPillAnimationStyle(index)}
              >
                <a
                  href={item.link_mobile}
                  target="_blank"
                  rel="noreferrer"
                  className="widget-pills__external-link widget-pills__external-link--mobile"
                  title={item.title}
                  onClick={() => eventTag(event?.name, event?.category, event?.action, item.title)}
                >
                  {content}
                </a>
                <a
                  href={item.link_desktop}
                  target="_blank"
                  rel="noreferrer"
                  className="widget-pills__external-link widget-pills__external-link--desktop"
                  title={item.title}
                  onClick={() => eventTag(event?.name, event?.category, event?.action, item.title)}
                >
                  {content}
                </a>
              </div>
            )
          }

          return (
            <div
              className="widget-pills__card animate__animated animate__fadeIn"
              key={item.id}
              style={getWidgetPillAnimationStyle(index)}
            >
              <Link
                to={`/pilula/${item.id}`}
                className="widget-pills__internal-link"
                onClick={() => eventTag(event?.name, event?.category, event?.action, item.title)}
                title={item.title}
              >
                {content}
              </Link>
            </div>
          )
        })}
      </div>

      <div className="widget-pills__all">
        <Link
          className="link"
          to="/pilulas"
          onClick={() => eventTag(event?.name, event?.category, event?.action, "Visualizar todos os conteúdos")}
        >
          Visualizar todos os conteúdos
          <span aria-hidden="true">›</span>
        </Link>
      </div>
    </div>
  ) : <></>
}

export default WidgetPills
